import { Grid, MenuItem, Typography } from '@material-ui/core'
import { PlanId } from 'commons/plan'
import * as R from 'ramda'
import React from 'react'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
export function renderPhysicalStarterPackMenuItem({
  formatMessage,
  plan = {},
  disabled,
}) {
  const planInfo = [
    {
      title: formatMessage({
        id: 'planAndBilling.yourPlan.changePlan.plan.starterPack.beacons',
      }),
      value: (
        <div className="flex items-start sm:items-center flex-col sm:flex-row">
          <Typography className="font-bold text-blue-primary ltr:mr-4 rtl:ml-4 text-10 sm:text-14">
            <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.starterPack.twoDevices" />
          </Typography>
          <Typography
            variant="caption"
            className="font-bold text-gray-600 text-10"
          >
            (
            <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.starterPack.buyOneGetOneBeacon" />
            )
          </Typography>
        </div>
      ),
    },
    {
      title: formatMessage({
        id: 'planAndBilling.yourPlan.changePlan.plan.starterPack.setUpAndMaintenance',
      }),
      value: formatMessage({
        id: 'planAndBilling.yourPlan.changePlan.plan.starterPack.included',
      }),
    },
    {
      title: formatMessage({
        id: 'planAndBilling.yourPlan.changePlan.plan.starterPack.notifications',
      }),
      value: formatMessage(
        {
          id: 'planAndBilling.yourPlan.changePlan.plan.starterPack.perYear',
        },
        {
          price: R.propOr(0, 'notesQuantity', plan),
        },
      ),
    },
    {
      title: formatMessage({
        id: 'planAndBilling.yourPlan.changePlan.plan.starterPack.customerSupport',
      }),
      value: formatMessage({
        id: 'planAndBilling.yourPlan.changePlan.plan.starterPack.included',
      }),
    },
    {
      title: formatMessage({
        id: 'planAndBilling.yourPlan.changePlan.plan.starterPack.shipping',
      }),
      value: formatMessage({
        id: 'planAndBilling.yourPlan.changePlan.plan.starterPack.included',
      }),
    },
  ]
  return (
    <MenuItem
      key={'starter-pack'}
      value={PlanId.PHYSICAL_WEB_STARTER_PACK}
      disabled={disabled}
      className={clsx(
        {
          'bg-gray-400': disabled,
        },
        'border-1 border-gray-400 border-solid hover:border-blue-primary m-12 p-12 rounded',
      )}
    >
      <div className="flex flex-col">
        <div className="flex justify-between w-full">
          <div className="flex flex-col">
            <div className="flex items-center">
              <Typography
                variant="caption"
                className="uppercase px-2 text-white rounded ltr:mr-8 rtl:ml-8 bg-watermelon font-bold"
              >
                <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.starterPack.newPackage" />
              </Typography>
              <Typography className="text-blue-primary text-10 sm:text-14">
                <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.starterPack.buyOneGetOneBeacon" />
              </Typography>
            </div>
            <Typography
              className="uppercase pt-8 text-14 sm:text-20"
              variant="h6"
            >
              {plan.name}
            </Typography>
            <Typography
              className="pb-8 text-gray-600 text-10 max-w-128"
              variant="caption"
            >
              <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.section.description" />
            </Typography>
          </div>
          <div className="flex flex-col items-end">
            <Typography
              variant="caption"
              className="text-gray-600 text-10 sm:text-14"
            >
              <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.starterPack.annually" />
            </Typography>
            <Typography
              variant="h6"
              className="font-bold text-blue-primary text-14 sm:text-20"
            >
              ${R.propOr(0, 'price', plan).toLocaleString()}
            </Typography>
          </div>
        </div>
        <Grid container>
          {planInfo.map((data, index) => {
            if (index % 2 === 0) {
              return (
                <Grid item xs="12" sm="6" container>
                  <Grid item xs="6" sm="6">
                    <Typography variant="caption">{data.title}</Typography>
                  </Grid>
                  <Grid item xs="6" sm="6">
                    {typeof data.value === 'string' ? (
                      <Typography className="font-bold text-blue-primary text-10 sm:text-14">
                        {data.value}
                      </Typography>
                    ) : (
                      data.value
                    )}
                  </Grid>
                </Grid>
              )
            }

            return (
              <Grid item xs="12" sm="6" container>
                <Grid item xs="6" sm="6">
                  <Typography variant="caption">{data.title}</Typography>
                </Grid>
                <Grid item xs="6" sm="6">
                  {typeof data.value === 'string' ? (
                    <Typography className="font-bold text-blue-primary sm:text-right text-10 sm:text-14">
                      {data.value}
                    </Typography>
                  ) : (
                    data.value
                  )}
                </Grid>
              </Grid>
            )
          })}
        </Grid>
      </div>
    </MenuItem>
  )
}
